// Runs `fn` over `items` with at most `limit` calls in flight at once.
// Each of the `limit` workers pulls the next item as soon as it's free,
// rather than waiting for a whole fixed-size batch to finish.
export async function mapWithConcurrency<T, R>(
  items: T[],
  limit: number,
  fn: (item: T, index: number) => Promise<R>,
): Promise<R[]> {
  const results: R[] = new Array(items.length)
  let cursor = 0

  const runWorker = async () => {
    while (cursor < items.length) {
      const current = cursor++
      results[current] = await fn(items[current], current)
    }
  }

  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, runWorker))
  return results
}
